export enum ContactBalanceCategoryRange {
  AverageRange = '16-30',
  LongRange = '31+',
  NotOverdue = 'notOverdue',
  ShortRange = '0-15',
}
